import React, { Fragment } from 'react';
import { convertDate } from '../../utils/utils';

function BugReportItem({ report, institutionName, tags, addTag, removeTag, allTags, toggleReportStatus }) {
  const { id, message, emailAddress, logUrl, isOpen, emailMe, institution, createdAt } = report;
  const unselectedTags = Object.entries(allTags).filter(([tagId]) => {
    const selectedIds = tags.map(tag => tag.id.toString());
    return selectedIds.indexOf(tagId) === -1;
  });
  return (
    <div className="bug-report-item">
      <p className="bug-report-item__label">
        {isOpen ? 'Open' : 'Closed'}
      </p>
      <p className="bug-report-item__text">
        {message}
      </p>
      <p className="bug-report-item__meta">
        <a href={logUrl} className="flat-link" target="_blank" rel="noopener noreferrer">See report in LogRocket</a>
        <span className="flat-link disabled">&nbsp;•&nbsp;</span>
        {emailMe
          ? <a href={'mailto:' + emailAddress} className="flat-link">Reply to user via email</a>
          : <span className="flat-link disabled">Reply to user via email</span>
        }
        <span className="flat-link disabled">&nbsp;•&nbsp;</span>
        <button type="button" onClick={() => toggleReportStatus(id)} className="flat-link-from-button">
          {isOpen
            ? 'Close ticket'
            : 'Reopen ticket'
          }
        </button>
      </p>
      <p className="bug-report-item__meta">
        <span className="bug-report-item__meta-label">Submitted:</span>
        {' '}
        {convertDate(createdAt)}
      </p>
      <p className="bug-report-item__meta">
        <span className="bug-report-item__meta-label">Institution:</span>
        {` ${institutionName} (ID ${institution})`}
      </p>
      <p className="bug-report-item__meta">
        <span className="bug-report-item__meta-label">Tagged:</span>
        {' '}
        {tags.map(tag => (
          <Fragment key={tag.id}>
            {tag.name}
            {' '}
            <button type="button" className="flat-link-from-button" onClick={() => removeTag(id, tag.id)}>×</button>
            &nbsp;&nbsp;
          </Fragment>
        ))}
        {unselectedTags.length > 0 && (
          <select onChange={e => addTag(id, e.target.value)} value="">
            <option value="" disabled>Add tag</option>
            {unselectedTags.map(([tagId, name]) => <option key={tagId} value={tagId}>{name}</option>)}
          </select>
        )}
      </p>
    </div>
  );
}

export default BugReportItem;



// WEBPACK FOOTER //
// ./src/components/common/BugReportItem.js